import { Controller } from 'stimulus';

class FitTextController extends Controller {
  connect() {
    this.onResize = () => this.fit();
    window.addEventListener('resize', this.onResize);

    requestAnimationFrame(() => this.fit());
  }

  disconnect() {
    window.removeEventListener('resize', this.onResize);

    this.fittyInstance?.unsubscribe();
  }

  fit() {
    const min = this.size('min-font-size', 16, 46);
    const max = this.size('max-font-size', 32, 80);

    this.fitMultiLine(min, max);
  }

  fitMultiLine(min, max) {
    const el = this.element;
    const parent = el.parentElement;

    if (!parent?.clientWidth || !parent.clientHeight) {
      return;
    }

    Object.assign(el.style, {
      whiteSpace: 'normal',
      display: 'block',
      width: '100%',
    });

    let low = min;
    let high = max;
    let best = min;

    while (low <= high) {
      const mid = Math.floor((low + high) / 2);
      el.style.fontSize = `${mid}px`;

      if (el.scrollHeight <= parent.clientHeight && el.scrollWidth <= parent.clientWidth) {
        best = mid;
        low = mid + 1;
      } else {
        high = mid - 1;
      }
    }

    el.style.fontSize = `${best}px`;
  }

  size(key, small, large) {
    if (this.data.has(key)) {
      return parseInt(this.data.get(key), 10);
    }

    const width = this.element.parentElement?.offsetWidth || this.element.offsetWidth;

    return width > 250 ? large : small;
  }
}

export default FitTextController;
